
document.addEventListener('DOMContentLoaded', function () {
  const countryDisplay = document.getElementById('custom-country-display');
  const countryOptions = document.getElementById('custom-country-options');
  const countrySelect = document.getElementById('country');

  const stateDisplay = document.getElementById('custom-state-display');
  const stateOptions = document.getElementById('custom-state-options');
  const stateSelect = document.getElementById('state');

  const button = document.getElementById('dekstech-notify-button');
  const form = document.querySelector('form');

  // Dropdown syncing
  function updateSelect(selectEl, value) {
    selectEl.value = value;
    selectEl.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function closeAllDropdowns() {
    countryOptions.style.display = 'none';
    stateOptions.style.display = 'none';
  }

  countryDisplay.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = countryOptions.style.display === 'block';
    closeAllDropdowns();
    if (!open) countryOptions.style.display = 'block';
  });

  stateDisplay.addEventListener('click', (e) => {
    e.stopPropagation();
    const open = stateOptions.style.display === 'block';
    closeAllDropdowns();
    if (!open) stateOptions.style.display = 'block';
  });

  document.addEventListener('click', closeAllDropdowns);

  countryOptions.querySelectorAll('li').forEach(option => {
    option.addEventListener('click', () => {
      const countryValue = option.getAttribute('data-value');
      const countryText = option.textContent;
      countryDisplay.textContent = countryText;
      countryDisplay.style.color = '#fff';
      updateSelect(countrySelect, countryValue);
      filterStateOptions(countryValue);
      resetStateDisplay();
    });
  });

  stateOptions.querySelectorAll('li').forEach(option => {
    option.addEventListener('click', () => {
      const stateValue = option.getAttribute('data-value');
      const stateText = option.textContent;
      stateDisplay.textContent = stateText;
      stateDisplay.style.color = '#fff';
      updateSelect(stateSelect, stateValue);
    });
  });

  function filterStateOptions(countryCode) {
    stateOptions.querySelectorAll('li').forEach(li => {
      li.style.display = li.getAttribute('data-country') === countryCode ? 'block' : 'none';
    });
  }

  function resetStateDisplay() {
    stateDisplay.textContent = 'Select your state';
    stateDisplay.style.color = '#999';
    updateSelect(stateSelect, '');
  }

  function syncInitialValues() {
    const defaultCountry = 'US';
    const currentCountry = countrySelect.value || defaultCountry;
    const currentState = stateSelect.value;
    updateSelect(countrySelect, currentCountry);

    const selectedCountryOption = countryOptions.querySelector(`li[data-value="${currentCountry}"]`);
    if (selectedCountryOption) {
      countryDisplay.textContent = selectedCountryOption.textContent;
      countryDisplay.style.color = '#fff';
    }

    filterStateOptions(currentCountry);

    if (currentState) {
      const selectedStateOption = stateOptions.querySelector(`li[data-value="${currentState}"]`);
      if (selectedStateOption) {
        stateDisplay.textContent = selectedStateOption.textContent;
        stateDisplay.style.color = '#fff';
      }
    } else {
      resetStateDisplay();
    }
  }

  syncInitialValues();

  // Autocomplete
  const addressInput = document.getElementById('address');
  const autocomplete = new google.maps.places.Autocomplete(addressInput, {
    types: ['address'],
    fields: ['address_components', 'formatted_address']
  });

  autocomplete.addListener('place_changed', () => {
    const place = autocomplete.getPlace();
    const components = place.address_components;

    const get = (type) => components.find(c => c.types.includes(type))?.long_name || '';
    const getShort = (type) => components.find(c => c.types.includes(type))?.short_name || '';

    const street = `${get('street_number')} ${get('route')}`.trim();
    document.getElementById('address').value = street;
    document.getElementById('city').value = get('locality') || get('sublocality') || '';
    document.getElementById('zipcode').value = get('postal_code');

    const countryCode = getShort('country');
    const stateName = get('administrative_area_level_1');

    // Sync country
    const matchedCountry = [...countryOptions.children].find(li => li.getAttribute('data-value') === countryCode);
    if (matchedCountry) {
      countryDisplay.textContent = matchedCountry.textContent;
      countryDisplay.style.color = '#fff';
      updateSelect(countrySelect, countryCode);
    }

    // Sync state
    filterStateOptions(countryCode);
    const matchedState = [...stateOptions.children].find(li => li.textContent.trim().toLowerCase() === stateName.trim().toLowerCase());
    if (matchedState) {
      stateDisplay.textContent = matchedState.textContent;
      stateDisplay.style.color = '#fff';
      updateSelect(stateSelect, matchedState.getAttribute('data-value'));
    }
  });

  // Helpers
  function getAddressValues() {
    return {
      address: document.getElementById('address')?.value.trim(),
      city: document.getElementById('city')?.value.trim(),
      state: document.getElementById('state')?.value.trim(),
      zip: document.getElementById('zipcode')?.value.trim(),
      country: document.getElementById('country')?.value.trim(),
      phone: document.getElementById('phone')?.value.trim()
    };
  }

async function validateAddressWithGoogle(fullAddress) {
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(fullAddress)}&key=AIzaSyD-ZJF6Ea3Ug1tPGnFWNIAe37p_TpJG-dA`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log('Geocode API response:', data);

    const result = data.results?.[0];

    const isValid = data.status === 'OK' &&
                    result &&
                    !result.partial_match;

    return isValid;
  } catch (err) {
    console.error('Address validation error:', err);
    return false;
  }
}


  function validatePhoneNumber(phone, countryCode) {
    try {
      const parsed = libphonenumber.parsePhoneNumber(phone, countryCode);
      return parsed.isValid();
    } catch {
      return false;
    }
  }

  // Final handler
  button.addEventListener('click', async (e) => {
    e.preventDefault();
const email = document.getElementById('email')?.value?.trim();
    const { address, city, state, zip, country, phone } = getAddressValues();

    if (!address || !city || !state || !zip || !country || !phone) {
      alert('Please fill in all required fields.');
      return;
    }

    const validPhone = validatePhoneNumber(phone, country);
    if (!validPhone) {
      alert('Please enter a valid phone number for your selected country.');
      return;
    }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    alert('Please enter a valid email address.');
    return;
  }
    
    const fullAddress = `${address}, ${city}, ${state}, ${zip}, ${country}`;
    const validAddress = await validateAddressWithGoogle(fullAddress);
    if (!validAddress) {
      alert('Please enter a valid address.');
      return;
    }

    // ✅ All valid — proceed
    const formData = new FormData(form);
    const data = {};

    formData.forEach((value, key) => {
      if (data[key]) {
        // Handle multiple fields with same name (e.g. checkboxes)
        if (Array.isArray(data[key])) {
          data[key].push(value);
        } else {
          data[key] = [data[key], value];
        }
      } else {
        data[key] = value;
      }
    });
const strongText = document.querySelector('.rte strong')?.textContent?.trim();
if (strongText) {
  data.interest = strongText; // or use a more specific key name
}
    else {
     data.interest = 'Email'; 
    }
    try {
      const response = await fetch('https://hooks.zapier.com/hooks/catch/17584645/2vyqc9n/', {
        method: 'POST',
        body: JSON.stringify(data)
      });

if (response.ok) {
  console.log('✅ Form submitted to Zapier successfully!');

  // ✅ Show success message
  const successMessage = document.createElement('p');
  successMessage.textContent = "Thank you! We’ll let you know as soon as it's ready.";
successMessage.style.color = 'green';
successMessage.style.fontWeight = 'bold';
successMessage.style.textAlign = 'center';
successMessage.style.marginTop = '1em';

// Insert after the button
button.parentNode.insertBefore(successMessage, button.nextSibling);

  // ✅ Disable submit button
 button.classList.add('disabled');

  button.textContent = 'Submitted';

  // Optional: hide the form completely
  // form.style.display = 'none';
}
 else {
        console.error('❌ Failed to send to Zapier', await response.text());
      }
    } catch (err) {
      console.error('❌ Error submitting form:', err);
    }
  });

});
